import React from 'react';
import CollapsibleItem from '../components/CollapsibleItem';
import TextInput from '../components/TextInput';
import SelectBtnInput from '../components/SelectBtnInput';
import ChildrenInput from '../components/ChildrenInput';
import { useSelector, useDispatch } from 'react-redux';
import { updateParents, setEqualTimeParents } from '../actions/parents';
import { updateChildrens } from '../actions/childrens';
import { updateSection } from '../actions/ui';

import * as label from '../constants';

const ParentsSection = () => {
  const dispatch = useDispatch();
  const parents = useSelector((state) => state.parents.parents);
  const childrensCount = useSelector((state) => state.childrens.childrensCount);
  const childrens = useSelector((state) => state.childrens.childrens);


  const updateParentsNames = (index,newName) => {
    const name = parents[index].name;
    if (newName===name ||
        (newName==='' && (name==='Parent 1' || name==='Parent 2'))) 
    {
      return;
    }
    dispatch(updateParents(index,'name',newName));
  }

  const updateChildrensName = (index,newName) => {
    const name = childrens[index].name;
    if ((newName===name) || (newName==='')) return;
    dispatch(updateChildrens(index,'name',newName));
  }

  const getChildrensNameLabel = (index) =>{
    if (index===0) return label.parentsSectionQuestions[4];
    return `What is the ${label.ordinals[index]} child’s name?`
  }

  return (
    <CollapsibleItem
      id={label.sectionIds.PARENTS_AND_CHILDREN}
    >
      <TextInput
        placeholder="Parent 1"
        label={label.parentsSectionQuestions[1]}
        onBlur={event => updateParentsNames(0,event.target.value)}
        maxLength={12}
        initialValue={parents[0].name}
      />
      <TextInput
        placeholder="Parent 2"
        label={label.parentsSectionQuestions[2]}
        onBlur={event => updateParentsNames(1,event.target.value)}
        maxLength={12}
        initialValue={parents[1].name}
      />
      <ChildrenInput
        label={label.parentsSectionQuestions[3]}
      />
      {childrens.map((item,index) => {
        if (index>childrensCount-1) return null;
        return (
          <TextInput
            placeholder={`Child ${index+1}`}
            initialValue={childrens[index].name}
            key={index}
            label={getChildrensNameLabel(index)}
            onBlur={event => updateChildrensName(index,event.target.value)}
            maxLength={12}
          />
        )
      })
      }
      {
        (childrensCount>1) && (
          <SelectBtnInput
            label={label.parentsSectionQuestions[5]}
            options={label.yesNoOptions}
            isTextField={false}
            updateValue={v => {
              dispatch(setEqualTimeParents(v));
              dispatch(updateSection(label.sectionIds.PARENTS_AND_CHILDREN));
            }}
          />
        )
      }

    </CollapsibleItem>
  )
}

export default ParentsSection;

